export default __webpack_public_path__ + "static/N0156-1e95fbe90250b88f7b70cb57d5ba3260.png";